<fgb-mobile-page-header [pageTitle]="'challenges.page.title'" backButtonLink="/" />
<fgb-banner class="d-lg-block d-none" [title]="'challenges.page.title' | translate" />

<div class="mobile-container">
  <div class="container">
    <div class="mt-lg-4 mt-3">
      <fgbcl-badge-achieved></fgbcl-badge-achieved>
    </div>
  </div>

  <div class="mt-lg-5 mt-3">
    <fgbcl-scorecard-list-view
      [icon]="'chevron_right'"
      [showPlaceholder]="true"
      [isSponsorInBody]="false"
    ></fgbcl-scorecard-list-view>
  </div>
</div>
